import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import StepIndicatorConnector from './StepIndicatorConnector';
import Completed from './Completed';
import RemainingSteps from './RemainingSteps';

const ContentsList = () => {
  const { completedSteps } = useSelector(state => state);
  const [isExpanded, setExpanded] = useState(false);

  return (
    <div
      className="PathContentsList JourneyContentsList"
      data-testid="JourneyContentsList"
    >
      {completedSteps > 0 && (
        <Completed isExpanded={isExpanded} setExpanded={setExpanded} />
      )}
      <RemainingSteps />
      <StepIndicatorConnector isExpanded={isExpanded} />
    </div>
  );
};

export default ContentsList;
